import {Component, inject} from '@angular/core';
import {MatRipple} from "@angular/material/core";
import {NgClass} from "@angular/common";
import {AuthService} from "../../services/auth.service";
import {Router, RouterLink, RouterModule} from "@angular/router";

@Component({
  selector: 'app-side-navigation',
  imports: [
    MatRipple,
    NgClass,
    RouterLink,
    RouterModule
  ],
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.scss'
})
export class SideNavigationComponent {


  auth = inject(AuthService)
  router = inject(Router);

  constructor() {
  }


  logoutClicked() {
    this.auth.signOut();
  }

  toggleDarkMode() {
    const bodyElement = document.body;
    bodyElement.classList.toggle('dark-mode');
  }

  getCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }
}
